// Translation dictionaries for EN / FR / AR.
// Long-form copy (treatment descriptions, FAQ answers, guide descriptions) stays in English for now
// and can be translated on user request. This keeps the file maintainable.
const translations = {
  en: {
    // Header / navigation
    'nav.home': 'Home',
    'nav.about': 'About Us',
    'nav.services': 'Services',
    'nav.blog': 'Blog',
    'nav.contact': 'Contact us',
    'nav.allServices': 'View all services',
    'cta.freeConsultation': 'Free Consultation',
    'cta.bookFreeConsultation': 'Book Free Consultation',
    'cta.getFreeQuote': 'Get Free Quote',
    'cta.chatWhatsApp': 'Chat on WhatsApp',
    'cta.learnMore': 'Learn more',
    'cta.readMore': 'Read more',
    'cta.visitBlog': 'Visit Blog',
    'topbar.reviews': 'Google Reviews',
    'topbar.patientsCountries': '{patients} Happy Patients from {countries} Countries',

    // Hero
    'hero.kicker': 'Gold Care Esthetic — Istanbul × Casablanca',
    'hero.title': 'Reveal your best version with luxury aesthetic care',
    'hero.sub': 'Experience premium plastic surgery and dental treatments with personalized care between Turkey and Morocco — where world-class surgeons, all-inclusive comfort, and absolute confidentiality meet.',
    'hero.urgency': 'By appointment only · Limited slots this month',
    'hero.istanbul': 'Istanbul',
    'hero.casablanca': 'Casablanca',
    'cta.getDiagnosis': 'Get your free diagnosis',
    'trust.0': 'Trusted by international patients',
    'trust.1': 'Personalized treatment plans',
    'trust.2': 'Premium all-inclusive care',
    'trust.3': 'Expert board-certified surgeons',
    'wa.tooltip': 'Chat with us on WhatsApp',
    'wa.online': 'Online now',
    'wa.headline': 'Talk to a medical advisor',
    'wa.sub': 'Get a personalized plan in 24 hours — free, confidential.',
    'wa.start': 'Start chat on WhatsApp',
    'sticky.headline': 'Ready for your transformation?',
    'sticky.sub': 'Limited consultations available · 100% confidential.',

    // Common section labels
    'section.overview': 'Overview',
    'section.whyChoose': 'Why choose',
    'section.yourJourney': 'Your {name} journey',
    'section.journey.desc': 'Four transparent steps from first message to full recovery.',
    'section.faq': 'Frequently asked questions',
    'section.moreFrom': 'More from {category}',
    'section.otherTreatments': 'Other treatments',
    'section.allServices': 'All services',
    'section.ready': 'Ready for your',
    'section.ready.sub': 'Get a free personalized quote within 24 hours. No credit card required, 100% confidential.',

    // Treatment page
    'treatment.atGoldCare': 'at Gold Care',
    'treatment.intro': 'Premium {name} performed by Gold Care Esthetic\u2019s board-certified specialists. World-class results, concierge-level care, and all-inclusive packages between Istanbul and Casablanca.',
    'treatment.quick.procedure': 'Procedure',
    'treatment.quick.anesthesia': 'Anesthesia',
    'treatment.quick.anesthesia.val': 'General / local',
    'treatment.quick.stay': 'Stay with Us',
    'treatment.quick.stay.val': '5\u20137 days',
    'treatment.quick.guarantee': 'Guarantee',
    'treatment.quick.guarantee.val': 'Lifetime',
    'treatment.procedureHours': '1\u20134 hours',

    // Guide section
    'guide.yourGuideTo': 'Your Guide to',
    'guide.stats.duration': 'Duration of Procedure',
    'guide.stats.return': 'Return to Activities',
    'guide.stats.hospitalization': 'Hospitalization Duration',
    'guide.stats.recovery': 'Complete Recovery',
    'guide.stats.results': 'Anticipated Results',
    'guide.stats.mobility': 'Mobility',

    // Gallery
    'gallery.title': '{name} Transformation:',
    'gallery.subtitle': 'Gold Care {name} Before and After',
    'gallery.caption': 'Be inspired by our patients\u2019 unbelievable transformation!',

    // Contact form
    'contact.tagline': 'Your transformation starts with one conversation. Share your goals — our medical advisors will design a personalized plan within 24 hours, completely free and confidential.',
    'contact.kicker': 'Free Personalized Diagnosis',
    'contact.headline': 'Begin your luxury aesthetic journey',
    'contact.urgency': 'Limited consultations available this month — by appointment only.',
    'contact.name': 'Name Surname',
    'contact.email': 'E-mail',
    'contact.phone': 'Phone',
    'contact.selectService': 'Select Service',
    'contact.message': 'Tell us about your goals — the more detail, the better the plan.',
    'contact.apply': 'Get my free diagnosis',
    'contact.success': 'Thank you! A medical advisor will contact you within 24 hours.',

    // Breadcrumbs
    'breadcrumb.home': 'Home',
    'breadcrumb.services': 'Services',

    // Categories
    'cat.body': 'Body Aesthetic',
    'cat.bariatrics': 'Bariatrics',
    'cat.breast': 'Breast Aesthetic',
    'cat.face': 'Face Aesthetic',
    'cat.hair': 'Hair Treatments',
    'cat.dentistry': 'Dentistry',

    // Treatment names
    'tr.tummy-tuck': 'Tummy Tuck',
    'tr.liposuction': 'Liposuction',
    'tr.bbl': 'BBL',
    'tr.mommy-makeover': 'Mommy Makeover',
    'tr.labiaplasty': 'Labiaplasty',
    'tr.penis-enlargement': 'Penis Enlargement',
    'tr.gastric-sleeve': 'Gastric Sleeve',
    'tr.gastric-bypass': 'Gastric Bypass',
    'tr.gastric-balloon': 'Gastric Balloon',
    'tr.mini-gastric-bypass': 'Mini Gastric Bypass',
    'tr.breast-augmentation': 'Breast Augmentation',
    'tr.breast-lift': 'Breast Lift',
    'tr.breast-reduction': 'Breast Reduction',
    'tr.gynecomastia': 'Gynecomastia',
    'tr.rhinoplasty': 'Rhinoplasty',
    'tr.facelift': 'Facelift',
    'tr.eyelid-surgery': 'Eyelid Surgery',
    'tr.otoplasty': 'Otoplasty',
    'tr.neck-lift': 'Neck Lift',
    'tr.chin-augmentation': 'Chin Augmentation',
    'tr.dhi-hair-transplant': 'DHI Hair Transplant',
    'tr.sapphire-fue': 'Sapphire FUE',
    'tr.afro-hair-transplant': 'Afro Hair Transplant',
    'tr.beard-transplant': 'Beard Transplant',
    'tr.eyebrow-transplant': 'Eyebrow Transplant',
    'tr.prp-therapy': 'PRP Therapy',
    'tr.hollywood-smile': 'Hollywood Smile',
    'tr.veneers': 'Veneers',
    'tr.dental-implants': 'Dental Implants',
    'tr.teeth-whitening': 'Teeth Whitening',
    'tr.dental-crowns': 'Dental Crowns',
    'tr.orthodontics': 'Orthodontics',

    // About / home sections
    'about.kicker': 'About Gold Care Esthetic',
    'about.title': 'Where science meets',
    'about.title.italic': 'natural beauty',
    'about.p1': 'Gold Care Esthetic is an internationally accredited aesthetic center operating between Istanbul and Casablanca. Our surgeons, dentists and hair specialists combine state-of-the-art technology with personalized artistry to deliver results that look and feel entirely you.',
    'about.p2': 'From your first online consultation to lifetime after-care, every step is organized by a dedicated coordinator. All-inclusive packages cover VIP transfers, 5-star accommodation and translation — so your only focus is feeling confident again.',
    'about.stat.surgeries': 'Successful surgeries',
    'about.stat.countries': 'Patient nationalities',
    'about.stat.experience': 'Years of expertise',
    'about.stat.rating': 'Patient rating',
    'about.pillar.0.title': 'Trust',
    'about.pillar.0.text': 'Every patient is guided with transparency from first consultation to full recovery.',
    'about.pillar.1.title': 'Precision',
    'about.pillar.1.text': 'Board-certified surgeons and modern facilities deliver predictable, natural results.',
    'about.pillar.2.title': 'Patient First',
    'about.pillar.2.text': 'Concierge-level care across Istanbul and Casablanca \u2014 your journey, handled end-to-end.',

    // Transform Naturally cards
    'tn.card.0.title': 'Meet our doctors',
    'tn.card.0.desc': 'Board-certified surgeons with decades of combined experience and thousands of successful cases.',
    'tn.card.0.cta': 'Learn more',
    'tn.card.1.title': 'Premium products only',
    'tn.card.1.desc': 'We use FDA / CE certified implants, threads and materials from the world\u2019s leading brands.',
    'tn.card.1.cta': 'Discover',

    // Committed Excellence
    'ce.checkTreatments': 'Check Treatments',

    // Clinic Highlights tabs
    'ch.tab.reception': 'Reception',
    'ch.tab.theater': 'Operating Rooms',
    'ch.tab.suites': 'Patient Suites',
    'ch.tab.lounge': 'VIP Lounge',

    // Location taglines
    'loc.tr.tagline': 'Flagship Clinic',
    'loc.ma.tagline': 'Africa HQ',

    // Before/after labels
    'ba.before': 'Before',
    'ba.after': 'After',

    // Before After home block
    'ba.kicker': 'Real Patients, Real Results',
    'ba.title': 'Your transformation journey',
    'ba.title.italic': 'Before & After',
    'ba.sub': 'See how patients from 80+ countries trusted Gold Care Esthetic to enhance their confidence.',

    // Committed Excellence
    'ce.kicker': 'Committed to Excellence',
    'ce.title': 'Gold-standard care,',
    'ce.title.italic': 'every single step',
    'ce.sub': 'Certified processes, a world-class team and absolute transparency — that is the Gold Care Esthetic promise.',

    // Transform Naturally
    'tn.kicker': 'The Gold Care Method',
    'tn.title': 'Transform',
    'tn.title.italic': 'naturally.',
    'tn.sub': 'Our philosophy: enhance what is uniquely you. No exaggerated features, no cookie-cutter results — only refined, timeless beauty.',

    // Clinic Highlights
    'ch.kicker': 'Inside Gold Care Esthetic',
    'ch.title': 'World-class facilities',
    'ch.title.italic': 'in Istanbul & Casablanca',
    'ch.sub': 'Modern operating theaters, luxury recovery suites and cutting-edge technology in both locations.',

    // Free consultation
    'fc.kicker': 'Free Consultation',
    'fc.title': 'Start your journey in 24 hours',
    'fc.sub': 'Share your goals and a few photos. Our medical advisors will reply with a personalized plan within a day.',

    // Availability calendar
    'avail.bookable': 'Live availability',
    'avail.helper': 'Tap an available date — we\u2019ll prefill the form for you.',
    'avail.open': 'Available',
    'avail.limited': 'Limited slots',
    'avail.booked': 'Fully booked',

    // Journey Reels
    'jr.kicker': 'Patient Stories',
    'jr.title': 'Journey reels',
    'jr.sub': 'Real patients share their Gold Care experience.',

    // Testimonials
    'tm.kicker': 'Patient Reviews',
    'tm.title': 'Trusted by',
    'tm.title.italic': 'thousands of patients',
    'tm.sub': 'Verified reviews from Wupdoc, Google and Instagram.',

    // Blog Posts
    'bp.kicker': 'Blog',
    'bp.title': 'Knowledge that',
    'bp.title.italic': 'empowers your journey',

    // Locations
    'loc.kicker': 'Global Presence',
    'loc.title': 'Two cities,',
    'loc.title.italic': 'one signature care',
    'loc.sub': 'Visit us in Istanbul or Casablanca — identical standards, identical results.',
    'loc.istanbul.addr': 'Esentepe, 34394 Şişli/Istanbul, Turkey',
    'loc.casablanca.addr': 'Boulevard Al Massira Al Khadra, Casablanca, Morocco',
    'loc.visit': 'Get directions',

    // Side contact
    'side.contact': 'Contact Us',

    // Footer
    'footer.about': 'About Gold Care',
    'footer.aboutDesc': 'Premium aesthetic surgery and dentistry across Istanbul & Casablanca. 100,000+ happy patients from 80+ countries.',
    'footer.quickLinks': 'Quick Links',
    'footer.services': 'Services',
    'footer.contact': 'Contact',
    'footer.rights': 'All rights reserved.',
    'footer.privacy': 'Privacy Policy',
    'footer.terms': 'Terms of Service',

    // Services Index page
    'servicesIndex.kicker': 'All Services',
    'servicesIndex.title': 'Our',
    'servicesIndex.title.italic': 'Treatments',
    'servicesIndex.sub': 'Explore every procedure offered at Gold Care Esthetic in Istanbul and Casablanca.',

    // Treatment page sections
    'tp.overview': 'Overview',
    'tp.whatIs': 'What is',
    'tp.overview.p1': '{name} is a premium {category} procedure designed to deliver natural, long-lasting results. At Gold Care Esthetic, our specialists combine proven techniques with the latest technology for predictable outcomes.',
    'tp.overview.p2': 'Every case is personalized: we begin with a detailed consultation, tailor a plan to your anatomy and goals, and accompany you through every step from arrival to full recovery.',
    'tp.overview.p3': 'Patients from over 80 countries choose Gold Care Esthetic for {name} thanks to our surgeons\u2019 reputation, modern facilities and transparent all-inclusive packages.',
    'tp.why.sub': 'Trusted by patients from over 80 countries for {name} and every step of the journey.',
    'tp.benefits.1.title': 'Board-certified surgeons',
    'tp.benefits.1.text': 'Operated by internationally trained experts with thousands of successful procedures.',
    'tp.benefits.2.title': 'JCI-standard safety',
    'tp.benefits.2.text': 'Fully-equipped modern facilities following international hygiene and safety protocols.',
    'tp.benefits.3.title': 'Natural-looking results',
    'tp.benefits.3.text': 'Technique refined to preserve your identity while enhancing confidence.',
    'tp.benefits.4.title': 'All-inclusive packages',
    'tp.benefits.4.text': 'Airport transfers, 5-star accommodation, translator and aftercare included.',
    'tp.process.1.title': 'Free Online Consultation',
    'tp.process.1.text': 'Share your goals and photos. Our medical advisors propose a personalized plan in 24 hours.',
    'tp.process.2.title': 'Arrival & Pre-Op Exam',
    'tp.process.2.text': 'VIP pickup, check-in to Gold Suites, and detailed examination with your surgeon.',
    'tp.process.3.title': 'Procedure Day',
    'tp.process.3.text': 'Performed in accredited theaters with the latest technology and anesthesia standards.',
    'tp.process.4.title': 'Recovery & Follow-Up',
    'tp.process.4.text': 'Comfortable recovery in our suites with 24/7 nurse access and lifetime follow-up.',
    'tp.faq.1.q': 'How long does the procedure take?',
    'tp.faq.1.a': 'Most procedures are performed in 1 to 4 hours depending on the treatment plan.',
    'tp.faq.2.q': 'Is the treatment painful?',
    'tp.faq.2.a': 'The procedure itself is performed under anesthesia. Mild discomfort during recovery is managed with prescribed medication.',
    'tp.faq.3.q': 'When can I return to daily activities?',
    'tp.faq.3.a': 'Light activity typically within 3\u20137 days; full recovery varies per procedure and is explained during consultation.',
    'tp.faq.4.q': 'What is included in the package?',
    'tp.faq.4.a': 'Surgery, hospital stay, medications, translator, VIP airport transfers, hotel accommodation, and lifetime aftercare support.',

    // Treatment-detail section labels
    'td.whatIs': 'What is',
    'td.candidate': 'Ideal Candidate',
    'td.procedure': 'How the Procedure Is Performed',
    'td.recovery': 'Recovery Timeline',
    'td.results': 'Results',
    'td.why': 'Why Gold Care Esthetic',
    'td.timeline.0': 'Days 1\u20133',
    'td.timeline.1': 'Week 1\u20132',
    'td.timeline.2': 'Month 1\u20133',
    'td.timeline.3': 'Final result',

    // Language switcher
    'lang.label': 'Language',
  },
  fr: {
    'nav.home': 'Accueil',
    'nav.about': 'À propos',
    'nav.services': 'Services',
    'nav.blog': 'Blog',
    'nav.contact': 'Contact',
    'nav.allServices': 'Voir tous les services',
    'cta.freeConsultation': 'Consultation gratuite',
    'cta.bookFreeConsultation': 'Réserver une consultation',
    'cta.getFreeQuote': 'Devis gratuit',
    'cta.chatWhatsApp': 'Discuter sur WhatsApp',
    'cta.learnMore': 'En savoir plus',
    'cta.readMore': 'Lire plus',
    'cta.visitBlog': 'Visiter le blog',
    'topbar.reviews': 'Avis Google',
    'topbar.patientsCountries': '{patients} patients satisfaits de {countries} pays',

    'hero.kicker': 'Gold Care Esthetic — Istanbul × Casablanca',
    'hero.title': 'Révélez votre meilleure version avec des soins esthétiques de luxe',
    'hero.sub': 'Vivez une chirurgie plastique et des soins dentaires premium avec un accompagnement personnalisé entre la Turquie et le Maroc — chirurgiens de renommée mondiale, confort tout inclus et confidentialité absolue.',
    'hero.urgency': 'Sur rendez-vous uniquement · Créneaux limités ce mois-ci',
    'hero.istanbul': 'Istanbul',
    'hero.casablanca': 'Casablanca',
    'cta.getDiagnosis': 'Obtenez votre diagnostic gratuit',
    'trust.0': 'Choisi par des patients internationaux',
    'trust.1': 'Plan de traitement personnalisé',
    'trust.2': 'Prise en charge premium tout inclus',
    'trust.3': 'Chirurgiens experts certifiés',
    'wa.tooltip': 'Discutez avec nous sur WhatsApp',
    'wa.online': 'En ligne maintenant',
    'wa.headline': 'Parlez à un conseiller médical',
    'wa.sub': 'Recevez un plan personnalisé sous 24 h — gratuit et confidentiel.',
    'wa.start': 'Démarrer la discussion',
    'sticky.headline': 'Prêt·e pour votre transformation ?',
    'sticky.sub': 'Consultations limitées · 100 % confidentiel.',

    'section.overview': 'Présentation',
    'section.whyChoose': 'Pourquoi choisir',
    'section.yourJourney': 'Votre parcours {name}',
    'section.journey.desc': 'Quatre étapes transparentes, du premier message au rétablissement complet.',
    'section.faq': 'Questions fréquentes',
    'section.moreFrom': 'Plus dans {category}',
    'section.otherTreatments': 'Autres traitements',
    'section.allServices': 'Tous les services',
    'section.ready': 'Prêt·e pour votre',
    'section.ready.sub': 'Recevez un devis personnalisé gratuit sous 24 h. Sans carte bancaire, 100 % confidentiel.',

    'treatment.atGoldCare': 'chez Gold Care',
    'treatment.intro': '{name} premium réalisé par les spécialistes certifiés de Gold Care Esthetic. Des résultats de classe mondiale, un service premium et des forfaits tout inclus entre Istanbul et Casablanca.',
    'treatment.quick.procedure': 'Procédure',
    'treatment.quick.anesthesia': 'Anesthésie',
    'treatment.quick.anesthesia.val': 'Générale / locale',
    'treatment.quick.stay': 'Séjour',
    'treatment.quick.stay.val': '5\u20137 jours',
    'treatment.quick.guarantee': 'Garantie',
    'treatment.quick.guarantee.val': 'À vie',
    'treatment.procedureHours': '1\u20134 heures',

    'guide.yourGuideTo': 'Votre guide pour',
    'guide.stats.duration': 'Durée de la procédure',
    'guide.stats.return': 'Retour aux activités',
    'guide.stats.hospitalization': 'Durée d\u2019hospitalisation',
    'guide.stats.recovery': 'Récupération complète',
    'guide.stats.results': 'Résultats attendus',
    'guide.stats.mobility': 'Mobilité',

    'gallery.title': 'Transformation {name} :',
    'gallery.subtitle': 'Avant & Après Gold Care {name}',
    'gallery.caption': 'Inspirez-vous de l\u2019incroyable transformation de nos patients !',

    'contact.tagline': 'Votre transformation commence par une conversation. Partagez vos objectifs — nos conseillers médicaux conçoivent un plan personnalisé sous 24 h, gratuitement et en toute confidentialité.',
    'contact.kicker': 'Diagnostic personnalisé gratuit',
    'contact.headline': 'Commencez votre parcours esthétique de luxe',
    'contact.urgency': 'Consultations limitées ce mois-ci — sur rendez-vous uniquement.',
    'contact.name': 'Nom Prénom',
    'contact.email': 'E-mail',
    'contact.phone': 'Téléphone',
    'contact.selectService': 'Sélectionner un service',
    'contact.message': 'Parlez-nous de vos objectifs — plus de détails, meilleur sera le plan.',
    'contact.apply': 'Recevoir mon diagnostic gratuit',
    'contact.success': 'Merci ! Un conseiller médical vous contactera sous 24 heures.',

    'breadcrumb.home': 'Accueil',
    'breadcrumb.services': 'Services',

    'cat.body': 'Esthétique du corps',
    'cat.bariatrics': 'Bariatrie',
    'cat.breast': 'Esthétique mammaire',
    'cat.face': 'Esthétique du visage',
    'cat.hair': 'Greffe de cheveux',
    'cat.dentistry': 'Dentisterie',

    'tr.tummy-tuck': 'Abdominoplastie',
    'tr.liposuction': 'Liposuccion',
    'tr.bbl': 'Brazilian Butt Lift',
    'tr.mommy-makeover': 'Mommy Makeover',
    'tr.labiaplasty': 'Labioplastie',
    'tr.penis-enlargement': 'Agrandissement pénien',
    'tr.gastric-sleeve': 'Sleeve gastrique',
    'tr.gastric-bypass': 'Bypass gastrique',
    'tr.gastric-balloon': 'Ballon gastrique',
    'tr.mini-gastric-bypass': 'Mini Bypass gastrique',
    'tr.breast-augmentation': 'Augmentation mammaire',
    'tr.breast-lift': 'Lifting des seins',
    'tr.breast-reduction': 'Réduction mammaire',
    'tr.gynecomastia': 'Gynécomastie',
    'tr.rhinoplasty': 'Rhinoplastie',
    'tr.facelift': 'Lifting du visage',
    'tr.eyelid-surgery': 'Chirurgie des paupières',
    'tr.otoplasty': 'Otoplastie',
    'tr.neck-lift': 'Lifting du cou',
    'tr.chin-augmentation': 'Augmentation du menton',
    'tr.dhi-hair-transplant': 'Greffe DHI',
    'tr.sapphire-fue': 'FUE Saphir',
    'tr.afro-hair-transplant': 'Greffe cheveux afro',
    'tr.beard-transplant': 'Greffe de barbe',
    'tr.eyebrow-transplant': 'Greffe de sourcils',
    'tr.prp-therapy': 'Thérapie PRP',
    'tr.hollywood-smile': 'Sourire Hollywood',
    'tr.veneers': 'Facettes dentaires',
    'tr.dental-implants': 'Implants dentaires',
    'tr.teeth-whitening': 'Blanchiment des dents',
    'tr.dental-crowns': 'Couronnes dentaires',
    'tr.orthodontics': 'Orthodontie',

    'about.kicker': 'À propos de Gold Care Esthetic',
    'about.title': 'Quand la science rencontre',
    'about.title.italic': 'la beauté naturelle',
    'about.p1': 'Gold Care Esthetic est un centre esthétique accrédité internationalement opérant entre Istanbul et Casablanca. Nos chirurgiens, dentistes et spécialistes capillaires combinent la technologie de pointe et l\u2019art personnalisé pour des résultats qui vous ressemblent vraiment.',
    'about.p2': 'De votre première consultation en ligne au suivi à vie, chaque étape est orchestrée par un coordinateur dédié. Nos forfaits tout inclus couvrent transferts VIP, hébergement 5 étoiles et traduction — vous n\u2019avez qu\u2019à reprendre confiance.',
    'about.stat.surgeries': 'Interventions réussies',
    'about.stat.countries': 'Nationalités de patients',
    'about.stat.experience': 'Années d\u2019expertise',
    'about.stat.rating': 'Note des patients',
    'about.pillar.0.title': 'Confiance',
    'about.pillar.0.text': 'Chaque patient est guidé en toute transparence, de la première consultation au rétablissement complet.',
    'about.pillar.1.title': 'Précision',
    'about.pillar.1.text': 'Chirurgiens certifiés et installations modernes pour des résultats prévisibles et naturels.',
    'about.pillar.2.title': 'Le patient d\u2019abord',
    'about.pillar.2.text': 'Une prise en charge premium entre Istanbul et Casablanca — votre parcours, géré de bout en bout.',

    'tn.card.0.title': 'Rencontrez nos médecins',
    'tn.card.0.desc': 'Chirurgiens certifiés avec des décennies d\u2019expérience cumulée et des milliers de cas réussis.',
    'tn.card.0.cta': 'En savoir plus',
    'tn.card.1.title': 'Produits premium uniquement',
    'tn.card.1.desc': 'Nous utilisons des implants, fils et matériaux certifiés FDA / CE des plus grandes marques mondiales.',
    'tn.card.1.cta': 'Découvrir',

    'ce.checkTreatments': 'Voir les traitements',

    'ch.tab.reception': 'Réception',
    'ch.tab.theater': 'Blocs opératoires',
    'ch.tab.suites': 'Suites patients',
    'ch.tab.lounge': 'Salon VIP',

    'loc.tr.tagline': 'Clinique phare',
    'loc.ma.tagline': 'Siège Afrique',

    'ba.before': 'Avant',
    'ba.after': 'Après',

    'ba.kicker': 'Vrais patients, vrais résultats',
    'ba.title': 'Votre transformation',
    'ba.title.italic': 'Avant & Après',
    'ba.sub': 'Découvrez comment des patients de plus de 80 pays ont fait confiance à Gold Care Esthetic.',

    'ce.kicker': 'Engagés pour l\u2019excellence',
    'ce.title': 'Des soins de référence,',
    'ce.title.italic': 'à chaque étape',
    'ce.sub': 'Processus certifiés, équipe de classe mondiale et transparence totale — c\u2019est la promesse Gold Care Esthetic.',

    'tn.kicker': 'La méthode Gold Care',
    'tn.title': 'Transformez-vous',
    'tn.title.italic': 'naturellement.',
    'tn.sub': 'Notre philosophie : sublimer ce qui vous rend unique. Pas de traits exagérés, uniquement une beauté raffinée et intemporelle.',

    'ch.kicker': 'À l\u2019intérieur de Gold Care Esthetic',
    'ch.title': 'Des installations de classe mondiale',
    'ch.title.italic': 'à Istanbul & Casablanca',
    'ch.sub': 'Blocs opératoires modernes, suites de récupération de luxe et technologie de pointe dans nos deux sites.',

    'fc.kicker': 'Consultation gratuite',
    'fc.title': 'Lancez votre parcours en 24 heures',
    'fc.sub': 'Partagez vos objectifs et quelques photos. Nos conseillers médicaux vous répondent avec un plan personnalisé sous un jour.',

    'avail.bookable': 'Disponibilités en direct',
    'avail.helper': 'Touchez une date disponible — nous pré-remplissons le formulaire pour vous.',
    'avail.open': 'Disponible',
    'avail.limited': 'Places limitées',
    'avail.booked': 'Complet',

    'jr.kicker': 'Témoignages patients',
    'jr.title': 'Reels de parcours',
    'jr.sub': 'Des patients réels partagent leur expérience Gold Care.',

    'tm.kicker': 'Avis patients',
    'tm.title': 'La confiance de',
    'tm.title.italic': 'milliers de patients',
    'tm.sub': 'Avis vérifiés sur Wupdoc, Google et Instagram.',

    'bp.kicker': 'Blog',
    'bp.title': 'Le savoir qui',
    'bp.title.italic': 'porte votre parcours',

    'loc.kicker': 'Présence mondiale',
    'loc.title': 'Deux villes,',
    'loc.title.italic': 'une seule signature',
    'loc.sub': 'Rendez-nous visite à Istanbul ou Casablanca — mêmes standards, mêmes résultats.',
    'loc.istanbul.addr': 'Esentepe, 34394 Şişli/Istanbul, Turquie',
    'loc.casablanca.addr': 'Boulevard Al Massira Al Khadra, Casablanca, Maroc',
    'loc.visit': 'Itinéraire',

    'side.contact': 'Contact',

    'footer.about': 'À propos',
    'footer.aboutDesc': 'Chirurgie esthétique et dentaire premium à Istanbul & Casablanca. Plus de 100 000 patients satisfaits dans plus de 80 pays.',
    'footer.quickLinks': 'Liens rapides',
    'footer.services': 'Services',
    'footer.contact': 'Contact',
    'footer.rights': 'Tous droits réservés.',
    'footer.privacy': 'Politique de confidentialité',
    'footer.terms': 'Conditions d\u2019utilisation',

    'servicesIndex.kicker': 'Tous les services',
    'servicesIndex.title': 'Nos',
    'servicesIndex.title.italic': 'traitements',
    'servicesIndex.sub': 'Explorez chaque procédure proposée par Gold Care Esthetic à Istanbul et Casablanca.',

    'tp.overview': 'Présentation',
    'tp.whatIs': 'Qu\u2019est-ce que',
    'tp.overview.p1': 'La {name} est une procédure {category} premium conçue pour offrir des résultats naturels et durables. Chez Gold Care Esthetic, nos spécialistes combinent techniques éprouvées et technologies de pointe pour des résultats prévisibles.',
    'tp.overview.p2': 'Chaque cas est personnalisé : nous commençons par une consultation détaillée, adaptons un plan à votre anatomie et à vos objectifs, et vous accompagnons à chaque étape jusqu\u2019au rétablissement complet.',
    'tp.overview.p3': 'Des patients de plus de 80 pays choisissent Gold Care Esthetic pour la {name} grâce à la réputation de nos chirurgiens, à nos installations modernes et à nos forfaits tout inclus transparents.',
    'tp.why.sub': 'La confiance de patients de plus de 80 pays pour la {name} et chaque étape du parcours.',
    'tp.benefits.1.title': 'Chirurgiens certifiés',
    'tp.benefits.1.text': 'Opérés par des experts formés à l\u2019international avec des milliers de procédures réussies.',
    'tp.benefits.2.title': 'Sécurité aux normes JCI',
    'tp.benefits.2.text': 'Installations modernes entièrement équipées suivant les protocoles internationaux d\u2019hygiène et de sécurité.',
    'tp.benefits.3.title': 'Résultats naturels',
    'tp.benefits.3.text': 'Technique affinée pour préserver votre identité tout en renforçant la confiance.',
    'tp.benefits.4.title': 'Forfaits tout inclus',
    'tp.benefits.4.text': 'Transferts aéroport, hébergement 5 étoiles, traducteur et suivi inclus.',
    'tp.process.1.title': 'Consultation en ligne gratuite',
    'tp.process.1.text': 'Partagez vos objectifs et photos. Nos conseillers proposent un plan personnalisé sous 24 h.',
    'tp.process.2.title': 'Arrivée & examen pré-opératoire',
    'tp.process.2.text': 'Récupération VIP, installation aux Gold Suites et examen détaillé avec votre chirurgien.',
    'tp.process.3.title': 'Jour de la procédure',
    'tp.process.3.text': 'Réalisée dans des blocs accrédités avec les dernières technologies et standards d\u2019anesthésie.',
    'tp.process.4.title': 'Récupération & suivi',
    'tp.process.4.text': 'Récupération confortable dans nos suites avec accès infirmier 24/7 et suivi à vie.',
    'tp.faq.1.q': 'Combien de temps dure l\u2019intervention ?',
    'tp.faq.1.a': 'La plupart des procédures durent de 1 à 4 heures selon le plan de traitement.',
    'tp.faq.2.q': 'Le traitement est-il douloureux ?',
    'tp.faq.2.a': 'La procédure elle-même se fait sous anesthésie. La gêne légère pendant la récupération est gérée par des médicaments prescrits.',
    'tp.faq.3.q': 'Quand puis-je reprendre mes activités ?',
    'tp.faq.3.a': 'Activité légère sous 3 à 7 jours en général ; le rétablissement complet varie selon la procédure et est expliqué lors de la consultation.',
    'tp.faq.4.q': 'Qu\u2019inclut le forfait ?',
    'tp.faq.4.a': 'Chirurgie, hospitalisation, médicaments, traducteur, transferts VIP, hébergement et suivi à vie.',

    'td.whatIs': 'Qu\u2019est-ce que',
    'td.candidate': 'Candidat idéal',
    'td.procedure': 'Déroulement de la procédure',
    'td.recovery': 'Calendrier de récupération',
    'td.results': 'Résultats',
    'td.why': 'Pourquoi Gold Care Esthetic',
    'td.timeline.0': 'Jours 1\u20133',
    'td.timeline.1': 'Semaines 1\u20132',
    'td.timeline.2': 'Mois 1\u20133',
    'td.timeline.3': 'Résultat final',

    'lang.label': 'Langue',
  },
  ar: {
    'nav.home': 'الرئيسية',
    'nav.about': 'من نحن',
    'nav.services': 'الخدمات',
    'nav.blog': 'المدونة',
    'nav.contact': 'اتصل بنا',
    'nav.allServices': 'عرض جميع الخدمات',
    'cta.freeConsultation': 'استشارة مجانية',
    'cta.bookFreeConsultation': 'احجز استشارة مجانية',
    'cta.getFreeQuote': 'احصل على عرض سعر',
    'cta.chatWhatsApp': 'تحدث عبر واتساب',
    'cta.learnMore': 'اعرف المزيد',
    'cta.readMore': 'اقرأ المزيد',
    'cta.visitBlog': 'زيارة المدونة',
    'topbar.reviews': 'تقييمات جوجل',
    'topbar.patientsCountries': '{patients} مريض سعيد من {countries} دولة',

    'hero.kicker': 'جولد كير إستيتيك — إسطنبول × الدار البيضاء',
    'hero.title': 'اكتشف نسختك الأفضل مع رعاية تجميلية فاخرة',
    'hero.sub': 'تجربة جراحة تجميل وعلاجات أسنان متميزة برعاية شخصية بين تركيا والمغرب — جراحون بمستوى عالمي، راحة شاملة، وسرية تامة.',
    'hero.urgency': 'بحجز مسبق فقط · أماكن محدودة هذا الشهر',
    'hero.istanbul': 'إسطنبول',
    'hero.casablanca': 'الدار البيضاء',
    'cta.getDiagnosis': 'احصل على تشخيصك المجاني',
    'trust.0': 'ثقة مرضى من جميع أنحاء العالم',
    'trust.1': 'خطة علاج مخصصة لك',
    'trust.2': 'رعاية فاخرة شاملة',
    'trust.3': 'جراحون خبراء معتمدون',
    'wa.tooltip': 'تحدث معنا عبر واتساب',
    'wa.online': 'متصل الآن',
    'wa.headline': 'تحدث مع مستشار طبي',
    'wa.sub': 'احصل على خطة مخصصة خلال 24 ساعة — مجانية وسرية.',
    'wa.start': 'ابدأ المحادثة',
    'sticky.headline': 'هل أنت مستعد لتحولك؟',
    'sticky.sub': 'استشارات محدودة · سرية تامة 100٪.',

    'section.overview': 'نظرة عامة',
    'section.whyChoose': 'لماذا تختار',
    'section.yourJourney': 'رحلتك مع {name}',
    'section.journey.desc': 'أربع خطوات شفافة من أول رسالة حتى التعافي الكامل.',
    'section.faq': 'الأسئلة الشائعة',
    'section.moreFrom': 'المزيد من {category}',
    'section.otherTreatments': 'علاجات أخرى',
    'section.allServices': 'جميع الخدمات',
    'section.ready': 'هل أنت مستعد لـ',
    'section.ready.sub': 'احصل على عرض سعر مخصص مجاني خلال 24 ساعة. دون الحاجة لبطاقة ائتمان، وسرية تامة 100٪.',

    'treatment.atGoldCare': 'في جولد كير',
    'treatment.intro': '{name} متميز يجريه أطباء معتمدون في جولد كير إستيتيك. نتائج عالمية ورعاية فاخرة وباقات شاملة بين إسطنبول والدار البيضاء.',
    'treatment.quick.procedure': 'الإجراء',
    'treatment.quick.anesthesia': 'التخدير',
    'treatment.quick.anesthesia.val': 'كلي / موضعي',
    'treatment.quick.stay': 'مدة الإقامة',
    'treatment.quick.stay.val': '5\u20137 أيام',
    'treatment.quick.guarantee': 'الضمان',
    'treatment.quick.guarantee.val': 'مدى الحياة',
    'treatment.procedureHours': '1\u20134 ساعات',

    'guide.yourGuideTo': 'دليلك إلى',
    'guide.stats.duration': 'مدة العملية',
    'guide.stats.return': 'العودة للنشاط',
    'guide.stats.hospitalization': 'مدة الإقامة بالمستشفى',
    'guide.stats.recovery': 'التعافي الكامل',
    'guide.stats.results': 'النتائج المتوقعة',
    'guide.stats.mobility': 'الحركة',

    'gallery.title': 'تحول {name}:',
    'gallery.subtitle': 'قبل وبعد {name} في جولد كير',
    'gallery.caption': 'استلهم من التحول المذهل لمرضانا!',

    'contact.tagline': 'يبدأ تحولك بمحادثة واحدة. شاركنا أهدافك — يصمم لك مستشارونا الطبيون خطة مخصصة خلال 24 ساعة، مجاناً وبسرية تامة.',
    'contact.kicker': 'تشخيص مخصص مجاني',
    'contact.headline': 'ابدأ رحلتك التجميلية الفاخرة',
    'contact.urgency': 'استشارات محدودة هذا الشهر — بحجز مسبق فقط.',
    'contact.name': 'الاسم الكامل',
    'contact.email': 'البريد الإلكتروني',
    'contact.phone': 'الهاتف',
    'contact.selectService': 'اختر الخدمة',
    'contact.message': 'أخبرنا عن أهدافك — كلما زادت التفاصيل، كانت الخطة أدق.',
    'contact.apply': 'احصل على تشخيصي المجاني',
    'contact.success': 'شكراً لك! سيتواصل معك مستشار طبي خلال 24 ساعة.',

    'breadcrumb.home': 'الرئيسية',
    'breadcrumb.services': 'الخدمات',

    'cat.body': 'تجميل الجسم',
    'cat.bariatrics': 'جراحات السمنة',
    'cat.breast': 'تجميل الصدر',
    'cat.face': 'تجميل الوجه',
    'cat.hair': 'زراعة الشعر',
    'cat.dentistry': 'طب الأسنان',

    'tr.tummy-tuck': 'شد البطن',
    'tr.liposuction': 'شفط الدهون',
    'tr.bbl': 'تكبير المؤخرة البرازيلي',
    'tr.mommy-makeover': 'تجديد ما بعد الأمومة',
    'tr.labiaplasty': 'تجميل الشفرتين',
    'tr.penis-enlargement': 'تكبير العضو الذكري',
    'tr.gastric-sleeve': 'تكميم المعدة',
    'tr.gastric-bypass': 'تحويل المسار',
    'tr.gastric-balloon': 'بالون المعدة',
    'tr.mini-gastric-bypass': 'تحويل مسار مصغر',
    'tr.breast-augmentation': 'تكبير الصدر',
    'tr.breast-lift': 'شد الصدر',
    'tr.breast-reduction': 'تصغير الصدر',
    'tr.gynecomastia': 'تثدي الرجال',
    'tr.rhinoplasty': 'تجميل الأنف',
    'tr.facelift': 'شد الوجه',
    'tr.eyelid-surgery': 'جراحة الجفون',
    'tr.otoplasty': 'تجميل الأذنين',
    'tr.neck-lift': 'شد الرقبة',
    'tr.chin-augmentation': 'تكبير الذقن',
    'tr.dhi-hair-transplant': 'زراعة الشعر DHI',
    'tr.sapphire-fue': 'زراعة سافاير FUE',
    'tr.afro-hair-transplant': 'زراعة الشعر الأفريقي',
    'tr.beard-transplant': 'زراعة اللحية',
    'tr.eyebrow-transplant': 'زراعة الحواجب',
    'tr.prp-therapy': 'علاج PRP',
    'tr.hollywood-smile': 'ابتسامة هوليوود',
    'tr.veneers': 'فينير الأسنان',
    'tr.dental-implants': 'زراعة الأسنان',
    'tr.teeth-whitening': 'تبييض الأسنان',
    'tr.dental-crowns': 'تيجان الأسنان',
    'tr.orthodontics': 'تقويم الأسنان',

    'about.kicker': 'عن جولد كير إستيتيك',
    'about.title': 'حيث يلتقي العلم',
    'about.title.italic': 'بالجمال الطبيعي',
    'about.p1': 'جولد كير إستيتيك مركز تجميل معتمد دولياً يعمل بين إسطنبول والدار البيضاء. يجمع جراحونا وأطباء الأسنان وأخصائيو الشعر بين أحدث التقنيات والرعاية المخصصة لتقديم نتائج طبيعية تماماً.',
    'about.p2': 'من الاستشارة الأولى عبر الإنترنت إلى الرعاية مدى الحياة، ينظم كل خطوة منسق مخصص. باقاتنا الشاملة تغطي النقل VIP والإقامة 5 نجوم والترجمة — همّك الوحيد هو استعادة ثقتك.',
    'about.stat.surgeries': 'عمليات ناجحة',
    'about.stat.countries': 'جنسيات المرضى',
    'about.stat.experience': 'سنوات من الخبرة',
    'about.stat.rating': 'تقييم المرضى',
    'about.pillar.0.title': 'الثقة',
    'about.pillar.0.text': 'نرافق كل مريض بشفافية تامة من أول استشارة حتى التعافي الكامل.',
    'about.pillar.1.title': 'الدقة',
    'about.pillar.1.text': 'جراحون معتمدون ومنشآت حديثة تقدم نتائج طبيعية وموثوقة.',
    'about.pillar.2.title': 'المريض أولاً',
    'about.pillar.2.text': 'رعاية متميزة في إسطنبول والدار البيضاء — رحلتك من البداية حتى النهاية.',

    'tn.card.0.title': 'تعرف على أطبائنا',
    'tn.card.0.desc': 'جراحون معتمدون بخبرة تمتد لعقود وآلاف الحالات الناجحة.',
    'tn.card.0.cta': 'اعرف المزيد',
    'tn.card.1.title': 'منتجات فاخرة فقط',
    'tn.card.1.desc': 'نستخدم زرعات وخيوط ومواد معتمدة من FDA / CE لأفضل العلامات التجارية العالمية.',
    'tn.card.1.cta': 'اكتشف',

    'ce.checkTreatments': 'عرض العلاجات',

    'ch.tab.reception': 'الاستقبال',
    'ch.tab.theater': 'غرف العمليات',
    'ch.tab.suites': 'أجنحة المرضى',
    'ch.tab.lounge': 'صالة VIP',

    'loc.tr.tagline': 'الفرع الرئيسي',
    'loc.ma.tagline': 'المقر الإفريقي',

    'ba.before': 'قبل',
    'ba.after': 'بعد',

    'ba.kicker': 'مرضى حقيقيون، نتائج حقيقية',
    'ba.title': 'رحلة تحولك',
    'ba.title.italic': 'قبل وبعد',
    'ba.sub': 'شاهد كيف وثق مرضى من أكثر من 80 دولة بجولد كير إستيتيك لتعزيز ثقتهم.',

    'ce.kicker': 'ملتزمون بالتميز',
    'ce.title': 'رعاية بمعايير ذهبية',
    'ce.title.italic': 'في كل خطوة',
    'ce.sub': 'إجراءات معتمدة وفريق عالمي وشفافية تامة — هذا هو وعد جولد كير.',

    'tn.kicker': 'طريقة جولد كير',
    'tn.title': 'تحوّل',
    'tn.title.italic': 'بشكل طبيعي.',
    'tn.sub': 'فلسفتنا: إبراز ما يجعلك مميزاً. لا ملامح مبالغ فيها — فقط جمال راقٍ وخالد.',

    'ch.kicker': 'داخل جولد كير',
    'ch.title': 'منشآت على مستوى عالمي',
    'ch.title.italic': 'في إسطنبول والدار البيضاء',
    'ch.sub': 'غرف عمليات حديثة وأجنحة تعافٍ فاخرة وتقنيات متطورة في كلا الموقعين.',

    'fc.kicker': 'استشارة مجانية',
    'fc.title': 'ابدأ رحلتك خلال 24 ساعة',
    'fc.sub': 'شاركنا أهدافك وبعض الصور. سيرد عليك مستشارونا الطبيون بخطة مخصصة خلال يوم.',

    'avail.bookable': 'التوفر المباشر',
    'avail.helper': 'اختر تاريخاً متاحاً — سنملأ النموذج لك.',
    'avail.open': 'متاح',
    'avail.limited': 'أماكن محدودة',
    'avail.booked': 'محجوز بالكامل',

    'jr.kicker': 'قصص المرضى',
    'jr.title': 'لقطات الرحلة',
    'jr.sub': 'مرضى حقيقيون يشاركون تجربتهم مع جولد كير.',

    'tm.kicker': 'آراء المرضى',
    'tm.title': 'ثقة',
    'tm.title.italic': 'آلاف المرضى',
    'tm.sub': 'تقييمات موثّقة من Wupdoc وجوجل وإنستغرام.',

    'bp.kicker': 'المدونة',
    'bp.title': 'معرفة',
    'bp.title.italic': 'تدعم رحلتك',

    'loc.kicker': 'حضور عالمي',
    'loc.title': 'مدينتان،',
    'loc.title.italic': 'توقيع رعاية واحد',
    'loc.sub': 'زرنا في إسطنبول أو الدار البيضاء — نفس المعايير، نفس النتائج.',
    'loc.istanbul.addr': 'إسنتبه، 34394 شيشلي/إسطنبول، تركيا',
    'loc.casablanca.addr': 'شارع المسيرة الخضراء، الدار البيضاء، المغرب',
    'loc.visit': 'احصل على الاتجاهات',

    'side.contact': 'اتصل بنا',

    'footer.about': 'عن جولد كير',
    'footer.aboutDesc': 'جراحات تجميل وطب أسنان متميز في إسطنبول والدار البيضاء. أكثر من 100,000 مريض سعيد من أكثر من 80 دولة.',
    'footer.quickLinks': 'روابط سريعة',
    'footer.services': 'الخدمات',
    'footer.contact': 'اتصل',
    'footer.rights': 'جميع الحقوق محفوظة.',
    'footer.privacy': 'سياسة الخصوصية',
    'footer.terms': 'شروط الاستخدام',

    'servicesIndex.kicker': 'جميع الخدمات',
    'servicesIndex.title': 'علاجاتنا',
    'servicesIndex.title.italic': 'المتوفرة',
    'servicesIndex.sub': 'استكشف كل إجراء تقدمه جولد كير إستيتيك في إسطنبول والدار البيضاء.',

    'tp.overview': 'نظرة عامة',
    'tp.whatIs': 'ما هي',
    'tp.overview.p1': '{name} هي عملية {category} متميزة مصممة لتقديم نتائج طبيعية ودائمة. في جولد كير إستيتيك، يجمع متخصصونا بين التقنيات المجربة وأحدث التكنولوجيا لنتائج موثوقة.',
    'tp.overview.p2': 'كل حالة مخصصة: نبدأ باستشارة مفصلة ونصمم خطة تناسب تشريحك وأهدافك، ونرافقك في كل خطوة من الوصول إلى التعافي الكامل.',
    'tp.overview.p3': 'يختار مرضى من أكثر من 80 دولة جولد كير إستيتيك لـ{name} بفضل سمعة جراحينا ومرافقنا الحديثة وباقاتنا الشاملة الشفافة.',
    'tp.why.sub': 'ثقة مرضى من أكثر من 80 دولة في {name} وفي كل خطوة من الرحلة.',
    'tp.benefits.1.title': 'جراحون معتمدون',
    'tp.benefits.1.text': 'يقوم بإجرائها خبراء مدربون دولياً لديهم آلاف العمليات الناجحة.',
    'tp.benefits.2.title': 'سلامة بمعايير JCI',
    'tp.benefits.2.text': 'مرافق حديثة مجهزة بالكامل وفق بروتوكولات النظافة والسلامة الدولية.',
    'tp.benefits.3.title': 'نتائج طبيعية',
    'tp.benefits.3.text': 'تقنية دقيقة تحافظ على هويتك وتعزز ثقتك.',
    'tp.benefits.4.title': 'باقات شاملة',
    'tp.benefits.4.text': 'تشمل النقل من المطار والإقامة 5 نجوم والمترجم والرعاية بعد العملية.',
    'tp.process.1.title': 'استشارة مجانية عبر الإنترنت',
    'tp.process.1.text': 'شاركنا أهدافك وصورك. يقترح مستشارونا خطة مخصصة خلال 24 ساعة.',
    'tp.process.2.title': 'الوصول والفحص قبل العملية',
    'tp.process.2.text': 'استقبال VIP، وتسجيل في Gold Suites، وفحص مفصل مع جراحك.',
    'tp.process.3.title': 'يوم الإجراء',
    'tp.process.3.text': 'يتم في غرف عمليات معتمدة بأحدث التقنيات ومعايير التخدير.',
    'tp.process.4.title': 'التعافي والمتابعة',
    'tp.process.4.text': 'تعافٍ مريح في أجنحتنا مع وصول ممرضة 24/7 ومتابعة مدى الحياة.',
    'tp.faq.1.q': 'كم يستغرق الإجراء؟',
    'tp.faq.1.a': 'تتراوح معظم الإجراءات بين 1 و4 ساعات حسب خطة العلاج.',
    'tp.faq.2.q': 'هل العلاج مؤلم؟',
    'tp.faq.2.a': 'يتم الإجراء تحت التخدير. أي انزعاج بسيط أثناء التعافي يُدار بأدوية موصوفة.',
    'tp.faq.3.q': 'متى أعود لأنشطتي اليومية؟',
    'tp.faq.3.a': 'النشاط الخفيف عادة خلال 3\u20137 أيام؛ التعافي الكامل يختلف حسب الإجراء ويُوضّح أثناء الاستشارة.',
    'tp.faq.4.q': 'ماذا تشمل الباقة؟',
    'tp.faq.4.a': 'الجراحة والإقامة بالمستشفى والأدوية والمترجم والنقل VIP والإقامة بالفندق ودعم ما بعد العملية مدى الحياة.',

    'td.whatIs': 'ما هي',
    'td.candidate': 'المرشح المثالي',
    'td.procedure': 'كيف تتم العملية',
    'td.recovery': 'الجدول الزمني للتعافي',
    'td.results': 'النتائج',
    'td.why': 'لماذا جولد كير إستيتيك',
    'td.timeline.0': 'الأيام 1\u20133',
    'td.timeline.1': 'الأسبوع 1\u20132',
    'td.timeline.2': 'الشهر 1\u20133',
    'td.timeline.3': 'النتيجة النهائية',

    'lang.label': 'اللغة',
  },
};

export default translations;
